import apiClient from '../utils/apiClient';
import { createLiveDataClient } from './cityExplorerLiveData';

const liveData = createLiveDataClient('auth', (locationId, endpoint, params) => {
  const url = `/v2/city-explorer/data/locations/${encodeURIComponent(locationId)}/${endpoint}`;
  return params ? apiClient.get(url, { params }) : apiClient.get(url);
});

// API client for the City Explorer product (market-access / school-desert
// maps). Location/map/resource endpoints require City Explorer product access
// (see city_market_explorer_routes.py). Share-link CRUD uses the same auth;
// recipients of a link use cityExplorerPublicShareService instead.
const cityExplorerService = {
  listLocations: async () => {
    return await apiClient.get('/v2/city-explorer/locations');
  },

  getLocation: async (locationId) => {
    return await apiClient.get(`/v2/city-explorer/locations/${encodeURIComponent(locationId)}`);
  },

  getMapUrl: async (locationId, categoryId, fileId, disposition = 'inline') => {
    return await apiClient.get(
      `/v2/city-explorer/locations/${encodeURIComponent(locationId)}/maps/${encodeURIComponent(categoryId)}/${encodeURIComponent(fileId)}`,
      { params: { disposition } }
    );
  },

  // Signed URL for a presentation/documentation/data file. disposition
  // 'attachment' makes the browser save it under its original filename.
  getResourceUrl: async (locationId, resourceId, disposition = 'inline') => {
    return await apiClient.get(
      `/v2/city-explorer/locations/${encodeURIComponent(locationId)}/resources/${encodeURIComponent(resourceId)}/url`,
      { params: { disposition } }
    );
  },

  // Raw bytes, proxied through the API. The bucket has no CORS policy, so
  // the spreadsheet viewer cannot fetch a signed URL directly.
  getResourceContent: async (locationId, resourceId) => {
    return await apiClient.get(
      `/v2/city-explorer/locations/${encodeURIComponent(locationId)}/resources/${encodeURIComponent(resourceId)}/content`,
      { responseType: 'arraybuffer' }
    );
  },

  ...liveData,

  listShares: async (locationId) => {
    return await apiClient.get(
      `/v2/city-explorer/locations/${encodeURIComponent(locationId)}/shares`
    );
  },

  createShare: async (locationId, body) => {
    return await apiClient.post(
      `/v2/city-explorer/locations/${encodeURIComponent(locationId)}/shares`,
      body
    );
  },

  updateShare: async (shareId, body) => {
    return await apiClient.patch(
      `/v2/city-explorer/shares/${encodeURIComponent(shareId)}`,
      body
    );
  },

  revokeShare: async (shareId) => {
    return await apiClient.delete(`/v2/city-explorer/shares/${encodeURIComponent(shareId)}`);
  },
};

export default cityExplorerService;
